export const saveFile = (data, name, extension) => {
    const blobUrl = window.URL.createObjectURL(data);
    const temporaryElement = document.createElement('a');
    temporaryElement.style.display = 'none';
    temporaryElement.href = blobUrl;
    temporaryElement.download = sanitizeFileName(name) + extension;
    document.body.appendChild(temporaryElement);
    temporaryElement.click();
    window.URL.revokeObjectURL(blobUrl);
};

export const FileExtension = {
    PDF: '.pdf',
    XLS: '.xls',
};

export const sanitizeFileName = (filename) => {
    console.log('sanitizing')
    return filename
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_')  // Replace disallowed characters
        .replace(/[\u{0000}-\u{001F}]/gu, '_')   // Unicode control characters
        .replace(/\.+$/, '')                    // Remove trailing dots
        .trim();
};